import React from 'react';
import { Link } from 'react-router-dom';

export default function BillingCancel() {
  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <svg className="text-muted-foreground" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </div>
      <h1 className="mt-6 text-2xl font-bold text-foreground">Checkout canceled</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        No charge was made. You can subscribe whenever you’re ready.
      </p>
      <Link
        to="/pricing"
        className="mt-8 inline-flex min-h-[2.75rem] items-center justify-center rounded-xl bg-gradient-to-r from-primary to-accent px-8 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-opacity hover:opacity-95"
      >
        Back to Pricing
      </Link>
    </div>
  );
}
